export default __webpack_public_path__ + "static/media/151-blackboard.92e015b8.png";